import { Component, Input, Output, EventEmitter, ElementRef, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { TooltipPosition } from '../../models/tooltip.enum';

@Component({
  selector: 'app-tour-guide-tooltip',
  templateUrl: './tour-guide-tooltip.component.html',
  styleUrl: './tour-guide-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TourGuideTooltipComponent implements AfterViewChecked {
  @Input() text: string = '';
  @Input() header: string = 'Help';
  @Input() position: TooltipPosition = TooltipPosition.Right;
  @Output() closeTooltip = new EventEmitter<void>();

  private lastTitledText: string | null = null;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  get positionClass(): string {
    return (TooltipPosition[this.position] ?? 'bottom').toLowerCase();
  }

  onClose(): void {
    this.closeTooltip.emit();
  }

  // `text` is set imperatively by TooltipInjectorService (not through a
  // template binding), so ngOnChanges never fires for it — this catches every
  // re-render instead. Only re-scans when the content actually changed.
  ngAfterViewChecked(): void {
    if (this.text === this.lastTitledText) return;
    this.lastTitledText = this.text;
    this.setLinkTitles();
  }

  // Links whose display text differs from their URL (e.g. "click here") get
  // a native title tooltip on hover showing the actual destination. Runs
  // regardless of how the link's HTML was produced (freshly inserted,
  // imported, or predating this admin editor), unlike setting title only at
  // insertion time.
  private setLinkTitles(): void {
    const links = this.elementRef.nativeElement.querySelectorAll<HTMLAnchorElement>('.tooltip-content a[href]');
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href && link.textContent?.trim() !== href) {
        link.setAttribute('title', href);
      }
    });
  }
}
